import { createContext, useContext } from "react";

/**
 * Provides auth + capability matrix + wallets + dynamic option sources to every
 * builder component.
 * - appUserTypes: [{value,label}] tenant user types (for the user_type field)
 * - states: [{value,label}] (for the user_state field)
 * - schemeFilters: { states[], product_categories[], user_types[{id,name}] } when
 *   the rule targets a scheme — narrows user_type/state/category to the scheme's
 *   eligibility (a scheme pre-filters which events reach the rules engine).
 * - schemeId: the resolved target scheme id (or null).
 */
export const BuilderContext = createContext({
  token: null,
  tenantId: null,
  meta: null,
  wallets: [],
  eventType: null,
  appUserTypes: [],
  states: [],
  schemeFilters: null,
  schemeId: null,
  schemeIds: [],
});

export const useBuilder = () => useContext(BuilderContext);
